import getFeaturedProducers from './getFeaturedProducers'
import getParentProducerBySlug from './getParentProducerBySlug'
import getParentProducersSlugs from './getParentProducersSlugs'
import getProducerBySlug from './getProducerBySlug'
import getProducers from './getProducers'

const producersLib = {
  getFeaturedProducers,
  getParentProducerBySlug,
  getParentProducersSlugs,
  getProducerBySlug,
  getProducers
}

export default producersLib
